if (!customElements.get("related-collections")) {
    class RelatedCollections extends HTMLElement {
        connectedCallback() {
            this.links = this.querySelectorAll(".related-links");
            this.addEventListener("click", this.handleClick.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener("click", this.handleClick.bind(this));
        }

        handleClick(e) {            
            if (!e.target.href) return;
            const gtmData = {
                event: "related_categories",
            };
            window.dataLayer.push(gtmData);
        }
    }

    customElements.define("related-collections", RelatedCollections);
}
